import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectNewbuildingId = (state: IApplicationState): number => {
  const { id } = selectNewbuilding(state);

  return id;
};
